import { render, staticRenderFns } from "./TwProcessGroupListEditIpRequestTableItem.vue?vue&type=template&id=3a39fcf6&scoped=true&"
import script from "./TwProcessGroupListEditIpRequestTableItem.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListEditIpRequestTableItem.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupListEditIpRequestTableItem.vue?vue&type=style&index=0&id=3a39fcf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a39fcf6",
  null
  
)

export default component.exports